import { motion } from "framer-motion";
import { Button } from "ui-kit/Button";
import { useAccount } from "wagmi";
import { useConnectedWalletIcon } from "hooks/useConnectedWalletIcon";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import { formatAddress } from "utils";
import { ConnectWallet } from "assets/svgComponents/PresaleBlock/ConnectWallet";
import { WalletPopover } from "../Header/components/WalletPopover";
import clsx from "clsx";
import CrossCloseIcon from "assets/svgComponents/buyTokenForm/CrossCloseIcon";
import { t } from "i18next";
import AGNTHubIcon from "assets/svgComponents/PresaleBlock/AGNTHubIcon.svg";
import { Link } from "react-router-dom";

export default function AnimatedButton({
  isHeader = false,
}: {
  isHeader?: boolean;
}) {
  const { isConnected, address } = useAccount();
  const walletIcon = useConnectedWalletIcon();
  const { openConnectModal } = useConnectModal();
  const isWalletConnected = isConnected && address;

  return (
    <motion.div
      className="flex items-center justify-center max-lg:w-full"
      initial={{ opacity: !isHeader ? 0 : 1, y: !isHeader ? 20 : 0 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.5 }}
      viewport={{ once: true }}
    >
      <motion.button
        className={clsx(
          "w-[29.72vw] max-lg:w-full max-lg:p-[6.4vw] h-[7.22vw] max-lg:h-[27.73vw] flex items-center justify-center bg-[#F3F3F8] rounded-[2.78vw] max-lg:rounded-[10.67vw]",
          isHeader && "lg:!w-fit max-lg:w-full !p-0 !h-fit"
        )}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
      >
        <div
          className={clsx(
            "relative h-[3.89vw] max-lg:h-[13.33vw] rounded-[1.11vw] max-lg:rounded-[4.27vw] w-[26.39vw] max-lg:w-full",
            isHeader && "lg:!h-[3.05vw] lg:!w-fit max-lg:w-full max-lg:!h-fit"
          )}
        >
          {isHeader ? (
            isWalletConnected ? (
              <WalletPopover>
                <Button
                  className={clsx(
                    "inline-flex items-center justify-between pl-[1.53vw] max-lg:pl-[5.33vw] pr-[0.42vw] max-lg:pr-[2.13vw] py-[0.42vw] max-lg:py-[2.13vw] !rounded-[1.11vw] max-lg:!rounded-[4.27vw] border-none shadow-[0px_0.42vw_0.52vw_0px_#0000000f] max-lg:shadow-[0px_1vw_0.5vw_0px_#0000000f] h-[3.89vw] max-lg:h-full w-[26.39vw] max-lg:w-full bg-[linear-gradient(90deg,rgba(255,166,134,1)_0%,rgba(255,173,174,1)_40%,rgba(207,178,255,1)_100%),linear-gradient(0deg,rgba(233,235,243,1)_0%,rgba(233,235,243,1)_100%)] before:content-[''] before:absolute before:inset-0 before:p-[0.07vw] max-lg:before:p-[0.27vw] before:rounded-[1.11vw] max-lg:before:rounded-[4.27vw] before:[background:linear-gradient(107deg,rgba(255,255,255,1)_0%,rgba(255,255,255,0)_100%)] before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:z-[1] before:pointer-events-none hover:opacity-90 transition-opacity",
                    isHeader &&
                      "!flex-row-reverse !h-full lg:w-fit max-lg:w-full !gap-[0.9vw] max-lg:!h-fit max-lg:!p-[2vw] !px-[0.53vw] !pr-[0.9vw]  max-lg:before:!h-full max-lg:!shadow-none"
                  )}
                >
                  <>
                    {isHeader && (
                      <CrossCloseIcon
                        fill={"white"}
                        className={"size-[1.4vw] max-lg:size-[5.45vw]"}
                      />
                    )}
                    <span
                      className={clsx(
                        "font-normal text-white text-[1.67vw] max-lg:text-[6.4vw] tracking-[0] leading-[1.83vw] max-lg:leading-[7.0vw] whitespace-nowrap",
                        isHeader &&
                          "!text-14 !font-luxora-medium max-lg:!text-14m"
                      )}
                    >
                      <span>{formatAddress(address, 4, 3)}</span>
                    </span>

                    <div
                      className={clsx(
                        "flex bg-white rounded-[0.83vw] max-lg:rounded-[3.2vw] items-center justify-center w-[3.06vw] max-lg:w-[11.73vw] h-[3.06vw] max-lg:h-[11.73vw]",
                        isHeader &&
                          "!h-[1.94vw] !w-[1.94vw] !rounded-[0.53vw] max-lg:!h-[8.3vw] max-lg:!w-[8.3vw] max-lg:!rounded-[2.13vw]"
                      )}
                    >
                      <img
                        src={walletIcon}
                        className={clsx(
                          "max-lg:w-[9vw] max-lg:h-[9vw] w-[2vw] h-[2vw]",
                          isHeader &&
                            "w-[1.7vw] h-[1.7vw] max-lg:!h-[7vw] max-lg:!w-[7vw]"
                        )}
                        alt=""
                      />
                    </div>
                  </>
                </Button>
              </WalletPopover>
            ) : (
              <Button
                onClick={() => {
                  if (openConnectModal) {
                    openConnectModal();
                  }
                }}
                className={clsx(
                  "inline-flex items-center  justify-between pl-[1.53vw] max-lg:pl-[5.33vw] pr-[0.42vw] max-lg:pr-[2.13vw] py-[0.42vw] max-lg:py-[2.13vw] !rounded-[1.11vw] max-lg:!rounded-[4.27vw] border-none shadow-[0px_0.42vw_0.52vw_0px_#0000000f] max-lg:shadow-[0px_1.6vw_2vw_0px_#0000000f] h-[3.89vw] max-lg:h-full w-[26.39vw] max-lg:w-full bg-[linear-gradient(90deg,rgba(255,166,134,1)_0%,rgba(255,173,174,1)_40%,rgba(207,178,255,1)_100%),linear-gradient(0deg,rgba(233,235,243,1)_0%,rgba(233,235,243,1)_100%)] before:content-[''] before:absolute before:inset-0 before:p-[0.07vw] max-lg:before:p-[0.27vw] before:rounded-[1.11vw] max-lg:before:rounded-[4.27vw] before:[background:linear-gradient(107deg,rgba(255,255,255,1)_0%,rgba(255,255,255,0)_100%)] before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:z-[1] before:pointer-events-none hover:opacity-90 transition-opacity",
                  isHeader &&
                    "!flex-row-reverse max-lg:!justify-end !h-full lg:w-fit max-lg:w-full !gap-[0.9vw] max-lg:!gap-[2.13vw] max-lg:!h-fit max-lg:!p-[2vw] !px-[0.53vw] !pr-[0.9vw]  max-lg:before:!h-full max-lg:!shadow-none"
                )}
              >
                <>
                  <span
                    className={clsx(
                      "font-luxora-regular font-[400] text-white text-[1.67vw] max-lg:text-[4.26vw] leading-[1.83vw] max-lg:leading-[110%] whitespace-nowrap",
                      isHeader &&
                        "!text-14 !font-luxora-medium max-lg:!text-14m"
                    )}
                  >
                    Connect Wallet
                  </span>
                  <div
                    className={clsx(
                      "flex bg-white rounded-[0.83vw] max-lg:rounded-[2.13vw] items-center justify-center w-[3.06vw] max-lg:w-[9.06vw] h-[3.06vw] max-lg:h-[9.06vw]",
                      isHeader &&
                        "!h-[1.94vw] !w-[1.94vw] !rounded-[0.53vw] max-lg:!h-[8.3vw] max-lg:!w-[8.3vw] max-lg:!rounded-[2.13vw]"
                    )}
                  >
                    <ConnectWallet
                      className={clsx(
                        "max-lg:w-[4.62vw] max-lg:h-[4.62vw]",
                        isHeader && "w-[1.5vw] h-[1.5vw]"
                      )}
                    />
                  </div>
                </>
              </Button>
            )
          ) : (
            <div className="relative ">
              <Link to={"/dashboard"}>
                {" "}
                <Button
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  className={clsx(
                    "items-center pl-[1.53vw] flex !justify-between gap-[1.22vw] max-lg:pl-[5.33vw] pr-[0.42vw] max-lg:pr-[2.13vw] py-[0.42vw] max-lg:py-[2.13vw]",
                    " !rounded-[1.11vw] max-lg:!rounded-[4.27vw] border-none shadow-[0px_0.42vw_0.52vw_0px_#0000000f] max-lg:shadow-[0px_1vw_0.5vw_0px_#0000000f] h-[3.89vw]",
                    " max-lg:h-[13.33vw] w-[26.39vw] max-lg:w-full bg-[linear-gradient(90deg,rgba(255,166,134,1)_0%,rgba(255,173,174,1)_40%,rgba(207,178,255,1)_100%),linear-gradient(0deg,rgba(233,235,243,1)_0%,rgba(233,235,243,1)_100%)] ",
                    "before:content-[''] before:absolute before:inset-0 before:p-[0.07vw] max-lg:before:p-[0.27vw] before:rounded-[1.11vw] max-lg:before:rounded-[4.27vw] before:[background:linear-gradient(107deg,rgba(255,255,255,1)_0%,rgba(255,255,255,0)_100%)] ",
                    "before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:z-[1] before:pointer-events-none hover:opacity-90 transition-opacity",
                    isHeader &&
                      "!flex-row-reverse !h-full lg:w-fit max-lg:w-full !gap-[0.9vw] max-lg:!h-fit max-lg:!p-[2vw] !px-[0.53vw] !pr-[0.9vw]  max-lg:before:!h-full max-lg:!shadow-none"
                  )}
                >
                  <span
                    className={clsx(
                      "font-luxora-regular font-[400] text-white text-[1.67vw] max-lg:text-[4.26vw] leading-[1.83vw] max-lg:leading-[110%] whitespace-nowrap",
                      isHeader &&
                        "!text-14 !font-luxora-medium max-lg:!text-14m"
                    )}
                  >
                    {t("navigation.getAttsToken")}
                  </span>
                  <div className="flex bg-white rounded-[0.56vw] max-lg:rounded-[2.13vw] items-center justify-center w-[2.22vw] h-[2.22vw] max-lg:w-[8.3vw] max-lg:h-[8.3vw]">
                    <img src={AGNTHubIcon} alt="" />
                  </div>
                </Button>
              </Link>
            </div>
          )}
        </div>
      </motion.button>
    </motion.div>
  );
}
